import {isMobileViewport} from '../lib/utilities';
import Swiper, {Navigation, Pagination} from 'swiper';

class MultiCard {
  constructor(element) {
    this.element = element;
    this.swiper = null;
    this.nextButton = this.element.querySelector('[data-element="next"]');
    this.prevButton = this.element.querySelector('[data-element="prev"]');
    this.pagination = this.element.querySelector('[data-element="pagination"]');
  }

  init() {
    if (this.element.dataset.mobileSlider == 'true') {
      this.bindMatchMedia();

      if (isMobileViewport()) {
        this.swiperEnable();
      }
    }
  }

  /**
   * Bind Event Listeners according to media query
   */
  bindMatchMedia() {
    const width = 800;
    const widthMatch = window.matchMedia(`(min-width: ${width}px)`);

    widthMatch.addEventListener('change', (matchMedia) => {
      // If it matches then we are large screen
      if (matchMedia.matches) {
        this.swiperDisable();
      } else {
        this.swiperEnable();
      }
    });
  }

  swiperEnable() {
    this.swiper = new Swiper(this.element, {
      modules: [Navigation, Pagination],
      mousewheel: true,
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      pagination: {
        el: this.pagination,
        type: 'fraction',
      },
      slidesPerView: 1.25,
      spaceBetween: 24,
    });
  }

  swiperDisable() {
    this.swiper.destroy(true, true);
  }
}

const multicard = {
  init() {
    const multicardElements = document.querySelectorAll('[data-module="multicard"]');

    if (multicardElements && multicardElements.length) {
      multicardElements.forEach((element) => {
        const multicardElement = new MultiCard(element);
        multicardElement.init();
      });
    }
  },
};

export default multicard;
